import { jsxs as t, jsx as e } from "react/jsx-runtime";
import c from "clsx";
import s from "./chunk475.js";
const b = (n) => {
  const { children: o, onClickButton: i, isLoading: a = !1, isDisabled: l, size: m = "medium", width: r, className: d } = n;
  return /* @__PURE__ */ t(
    "button",
    {
      className: c(
        s.button,
        a && s.loading,
        l && s.disabled,
        s[m],
        d
      ),
      onClick: i,
      disabled: l,
      style: { width: r },
      children: [
        /* @__PURE__ */ e("span", { className: s.textWrapper, children: o }),
        a && /* @__PURE__ */ t("div", { className: s.loader, children: [
          /* @__PURE__ */ e("span", { className: s.loaderElement }),
          /* @__PURE__ */ e("span", { className: s.loaderElement }),
          /* @__PURE__ */ e("span", { className: s.loaderElement })
        ] })
      ]
    }
  );
};
export {
  b as Button
};
